import axios from 'axios';
import { getEnvironmentUrl } from '@/services/environment.helper.js';
import { company } from '@/services/auth';

// Cliente HTTP para telas públicas (sem login).
// Não usa os interceptors do Api (src/services/api.js): ele redireciona para /login em qualquer 401,
// mostra alert() nos erros e anexa o token do usuário. Aqui o erro volta intacto para a view tratar.
const publicApi = axios.create({
  baseURL: getEnvironmentUrl(),
  headers: {
    'Content-Type': 'application/json',
    KEY: company,
  },
});

export default publicApi;
